import { Regions } from 'api/types/ReferenceData';
import { Countries } from 'api/types/countries';
import { Product, TechnicalCategories, ValueProperties } from 'types/Products';

export const getTechnicalAttributes = (
  product: Product,
  attribute: keyof TechnicalCategories
) => {
  if (product.categories?.technical?.[attribute])
    if (attribute !== 'rci' && attribute !== 'usagelevel')
      return product?.categories?.technical?.[attribute]
        ?.map((item: { value: string }) => capitalizeFirstLetter(item.value))
        .join(', ');
    else
      return capitalizeFirstLetter(
        product?.categories?.technical?.[attribute]?.value ?? ''
      );
};

export const getRegionalAvailabilities = (
  product: Product,
  attribute: keyof {
    regions: ValueProperties[];
    countries: ValueProperties[];
  }
) =>
  product?.categories?.['regional-availability']?.[attribute]
    ?.map(
      el =>
        (attribute === 'regions' ? Regions : Countries).find(
          region => region.value === el.value
        )?.label
    )
    .join(', ');

export const filterAudit = (row: Product, searchValue: string) => {
  const { modified_at, modified_by, created_by } = row;
  const user = !modified_at ? created_by : modified_by;
  return user?.toLowerCase()?.includes(searchValue?.toLowerCase()) ?? false;
};

export const capitalizeFirstLetter = (str: string) =>
  str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
